import { FormattedMessage } from 'react-intl';

import { Heading } from '@shieldpay/bumblebee/heading';
import TextListMarkdown from '@shieldpay/bumblebee/markdown/text-list.md';
import { TextList } from '@shieldpay/bumblebee/text-list';

import { ContentsTable } from '~/components/contents-table/contents-table';
import { MdxFormatter } from '~/components/mdx-formatter/mdx-formatter';
import { ComponentPreview } from '~/components/preview/component-preview';
import { createMeta } from '~/utilities/create-meta';

export const meta = createMeta({
  id: 'hive.components.textList.title',
});

export const TextListComponentPage = () => {
  return (
    <>
      <Heading>
        <FormattedMessage id="hive.components.textList.title" />
      </Heading>

      <ContentsTable />

      <ComponentPreview alignContent={{ x: 'left' }}>
        <Heading level="3" variant="title">
          Unordered TextList
        </Heading>
        <TextList>
          <TextList.Item>
            That’s what it said on ‘Ask Jeeves’ He’ll want to use your yacht,
            and I don’t want this thing smelling like fish. Now, when you do
            this without getting punched in the chest, you’ll have more fun. I
            don’t understand the question, and I won’t respond to it.
          </TextList.Item>
          <TextList.Item>
            I don’t understand the question, and I won’t respond to it. I’m a
            monster. There’s so many poorly chosen words in that sentence. I’m a
            monster. Get me a vodka rocks. And a piece of toast. That’s why you
            always leave a note!
          </TextList.Item>
        </TextList>
        <Heading level="3" variant="title">
          Ordered TextList
        </Heading>
        <TextList ordered>
          <TextList.Item>
            That’s what it said on ‘Ask Jeeves’ He’ll want to use your yacht,
            and I don’t want this thing smelling like fish. Now, when you do
            this without getting punched in the chest, you’ll have more fun. I
            don’t understand the question, and I won’t respond to it.
          </TextList.Item>
          <TextList.Item>
            I don’t understand the question, and I won’t respond to it. I’m a
            monster. There’s so many poorly chosen words in that sentence. I’m a
            monster. Get me a vodka rocks. And a piece of toast. That’s why you
            always leave a note!
          </TextList.Item>
        </TextList>
      </ComponentPreview>

      <MdxFormatter md={TextListMarkdown} />
    </>
  );
};

export default TextListComponentPage;
